import { SxProps, Theme } from "@mui/material/styles";

const styles: SxProps<Theme> = [
  {
    "&.container": {
      position: "fixed",
      bottom: 24,
      right: 24,
      background: "#124779",
      color: "white",
      boxShadow: "0 0 10px rgba(0,0,0,0.2)",
      borderRadius: "16px",
      fontWeight: "700",
      padding: "0px !important",
      "& a": {
        fontSize: 17,
        letterSpacing: 0.5,
        lineHeight: "25px",
        padding: "16px 12px",
        paddingRight: "18px",
        color: "white",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
        "& svg": {
          marginRight: "10px",
        },
        "& .vertuloo-font-mdSm": {
          paddingLeft: "4px",
        },
      },
      "&:before": {
        content: '""',
        position: "absolute",
        background: "#124779",
        width: "28px",
        zIndex: -1,
        bottom: -6,
        right: 8,
        height: 28,
        transform: "rotate(45deg)",
      },
      "&:hover, &:focus": {
        background: "#082037",
        "&:before": { background: "#082037" },
      },
    },
    "& .text2": {
      fontSize: 20,
      letterSpacing: 1,
    },
    "@media all and (max-width: 789px)": {
      "&.container": {
        "& a": {
          fontSize: 14,
          "& span": {
            display: "flex",
          },
          "& .vertuloo-font-mdSm": {
            fontSize: 18,
            padding: "0 4px",
          },
        },
      },
      "& .text2": {
        fontSize: 14,
      },
    },
  },
];

export default styles;
